import {
  Bot,
  Lock,
  ShieldCheck,
  Gift,
  Wallet,
  Globe,
} from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ICONS = [Bot, Lock, ShieldCheck, Gift, Wallet, Globe];

const Features = () => {
  const { t } = useLanguage();

  return (
    <section
      id="features"
      aria-labelledby="features-heading"
      data-testid="features-section"
      className="relative py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <header className="max-w-3xl">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-[var(--brand)]">
            {t.features.kicker}
          </p>
          <h2
            id="features-heading"
            className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white"
          >
            {t.features.title}
          </h2>
        </header>

        <ul className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {t.features.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <li key={i} data-testid={`feature-card-${i}`}>
                <article className="group relative h-full rounded-2xl border border-white/10 bg-white/[0.03] p-6 md:p-7 hover:border-[rgb(var(--brand-rgb)/0.4)] transition-all hover:-translate-y-0.5">
                  <span
                    className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[rgb(var(--brand-rgb)/0.1)] text-[var(--brand)] mb-5 group-hover:bg-[var(--brand)] group-hover:text-black transition-colors"
                    aria-hidden="true"
                  >
                    <Icon className="h-6 w-6" strokeWidth={2.2} />
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-white tracking-tight">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-[15px] leading-relaxed text-zinc-200">
                    {item.desc}
                  </p>
                </article>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Features;
